/**
 * Single switch for the whole Digestion section: its report-body panel, its PDF
 * block (and that block's pagination entry), its Results Overview box, and its
 * comparison table. They are one feature, so they read one flag rather than each
 * repeating an env check that can drift — which is exactly how this section
 * shipped to prod ungated once already.
 *
 * ON HOLD as of 2026-08-31 — hidden EVERYWHERE, local dev included, not just the
 * deployed builds. It was on `visibleExceptProd()` while the data was being
 * built out, but the patterns are not ready to implement:
 *
 *   - The rules are strict ANDs with no handling for a marker that was not
 *     ordered, so four of the fourteen patterns can essentially never fire
 *     (Broad Micronutrient Depletion needs five separate panels to coincide:
 *     0.4% of tests; Gastric Immune Activation is dragged to 5.8% by a single
 *     ▼Phosphorus term). Glucose solves this by enumerating "no value" as a
 *     first-class marker state — 40% of its 150 rows exist for that — and
 *     Digestion has none of it yet.
 *   - There is still no DigestionAnalysis, so possibleRootCauseCategoriesFor
 *     has no DIGESTION case and the authored pattern rows reach nothing.
 *   - There is no insights panel or gauge.
 *
 * What would render today is a bare marker panel borrowed from other sections,
 * which is not a feature. A gate rather than ripped-out code so the wiring,
 * getDigestionPanelMarkers(), the PDF pagination unit and the comparison table
 * keep compiling and cannot rot while the pattern set is reworked.
 *
 * The DATA side is finished and unaffected: the sheet, both pull scripts and the
 * 14 patterns / 70 references in digestion-patterns.json stay as they are. This
 * hides UI only.
 *
 * TO RESUME: return `visibleExceptProd()` to put it back in front of the user on
 * slava, or delete this function and its call sites once the section ships. See
 * digestion-patterns-spec.md for the outstanding pattern work.
 */
export function digestionVisible(): boolean {
  return false;
}
